import React from 'react';

const NotFound = (props) => {
    return (
        <div className='not-found center-align'>
            <h2>404 - PAGE NOT FOUND</h2>
        </div>
    )
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js